import { render, staticRenderFns } from "./invitedDataInfo.vue?vue&type=template&id=4800ed84&"
import script from "./invitedDataInfo.vue?vue&type=script&lang=js&"
export * from "./invitedDataInfo.vue?vue&type=script&lang=js&"
import style0 from "./invitedDataInfo.vue?vue&type=style&index=0&id=4800ed84&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports